import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";

import "jspdf-autotable";
import { Row, Col, Container,Card } from "react-bootstrap";
import KpiService from "../../Services/KpiService";
import useAlert from "../Alert/useAlert";
import MasterService from "../../Services/MasterService";
import { Button } from "@mui/material";
import { VscSaveAs } from "react-icons/vsc";
import { FaEdit} from "react-icons/fa";
import AlertModal from "../Alert/AlertModal";
import {maskEmail,maskMobile} from "../utils/commonFunctions";

export default function UserDetails() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [Data, setData] = useState({});
  let username = localStorage.getItem("username");


  useEffect(() => {
    fetchEmployeeDetails({ userId: username });
  }, []);

  const fetchEmployeeDetails = async (params) => {
    try {
      store.dispatch({ type: "SHOW_SPINNER" });
      const res = await MasterService.getEmployeeDetails(params);
      if (res.data) {
        setData(res.data);
      } else {
        setData({});
      }
    } catch (err) {
      console.error("Error fetching employee details:", err);
      setData({});
    } finally {
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };

  const UpdateData = async () => {
    let params = {};
    if (Data?.type === "CORP") {
      params = { userId: Data?.userId, alternateMobileNo: Data?.mobileNumber, type: "CORP", empId: Data?.empId, emailId: Data?.emailId, empName: Data?.empName, gender: Data?.gender, };
      if(!params.empId){ showAlertMessage("Employee id required.","warning"); return; }
      if(!params.empName){ showAlertMessage("Employee name required","warning"); return; }
      if(!params.gender){ showAlertMessage("Gender required","warning"); return; }
      
    } else {
      params = { userId: Data?.userId, alternateMobileNo: Data?.alternateMobileNo, type: Data?.type, };
      if(!params.alternateMobileNo){ showAlertMessage("Alternate mobile no required.","warning"); return; }
    }

    try {
      store.dispatch({ type: "SHOW_SPINNER" });
      const res = await KpiService.updatealternatemobile(params);
      if (res?.data) { showAlertMessage(res.data, "success", () => { fetchEmployeeDetails({ userId: username }); }); }
    } catch (err) {
      console.error("Update failed:", err);
      showAlertMessage("Something went wrong", "error");
    } finally {
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };


  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "85%" }}> <div className="sa-title"> <h2> User<span> Details</span> </h2> </div> </Container>
      <Container fluid style={{ width: "85%", marginBottom: "150px" }}>
        {Data && Data?.userId && (
          <Card className="shadow rounded-2">
            <Card.Body>
              <Row>
                <Col xxl={4} xl={4} lg={4} md={6} sm={12} className="mb-4"> <span className="fw-bold me-2">User Id:</span> <input type="text" disabled={true} className="form-control" value={Data?.userId || ""} onChange={(e) => setData({ ...Data, userId: e.target.value })}  /> </Col>

                <Col xxl={4} xl={4} lg={4} md={6} sm={12} className="mb-4"> <span className="fw-bold me-2">Employee Name:</span> <div className="input-group input-group-sm user" style={{ flex: 1 }}> <input type="text" disabled={Data?.type !== "CORP"} className="form-control" value={Data?.empName || ""} onChange={(e) => setData({ ...Data, empName: e.target.value })}  /> {Data?.type == "CORP" && ( <span className="input-group-text"> <FaEdit style={{ fontSize: "16px" }} /> </span> )} </div> </Col>

                {Data?.type == "CORP" ? (
                  <Col xxl={4} xl={4} lg={4} md={6} sm={12} className="mb-4"> <span className="fw-bold me-2">Employee Id:</span> <div className="input-group input-group-sm user" style={{ flex: 1 }}> <input type="text" className="form-control" value={Data?.empId || ""} onChange={(e) => setData({ ...Data, empId: e.target.value })} /> <span className="input-group-text"> <FaEdit style={{ fontSize: "16px" }} /> </span> </div> </Col>
                ) : (
                  <Col xxl={4} xl={4} lg={4} md={6} sm={12} className="mb-4"> <span className="fw-bold me-2">CFMS Id:</span> <input type="text" disabled={true} className="form-control" value={Data?.cfmsid || ""} onChange={(e) => setData({ ...Data, cfmsid: e.target.value })}  /> </Col>
                )}

                <Col xxl={4} xl={4} lg={4} md={6} sm={12} className="mb-4"> <span className="fw-bold me-2">Department Name:</span> <input type="text" disabled={true} className="form-control" value={Data?.deptName || ""} onChange={(e) => setData({ ...Data, deptName: e.target.value })}  /> </Col>

                {Data?.type !== "CORP" && (
                  <>
                    <Col xxl={4} xl={4} lg={4} md={6} sm={12} className="mb-4"> <span className="fw-bold me-2">DDO Name:</span> <input type="text" disabled={Data?.type !== "CORP"} className="form-control" value={Data?.ddocode || ""} onChange={(e) => setData({ ...Data, ddocode: e.target.value })}  /> </Col>
                    <Col xxl={4} xl={4} lg={4} md={6} sm={12} className="mb-5"> <span className="fw-bold me-2">Organisation Name:</span> <input type="text" disabled={Data?.type !== "CORP"} className="form-control" value={Data?.orgName || ""} onChange={(e) => setData({ ...Data, orgName: e.target.value })}  /> </Col>
                    <Col xxl={4} xl={4} lg={4} md={6} sm={12} className="mb-5"> <span className="fw-bold me-2">Position:</span> <input type="text" disabled={Data?.type !== "CORP"} className="form-control" value={Data?.positionName || ""} onChange={(e) => setData({ ...Data, positionName: e.target.value })}  /> </Col>
                  </>
                )}

                <Col xxl={4} xl={4} lg={4} md={6} sm={12} className="mb-4"> <span className="fw-bold me-2">Gender:</span> <div className="input-group input-group-sm user" style={{ flex: 1 }}> <select disabled={Data?.type !== "CORP"} className="form-control" value={Data?.gender || ""} onChange={(e) => setData({ ...Data, gender: e.target.value })}> <option value="">Select</option> <option value="Male">Male</option> <option value="Female">Female</option> <option value="Other">Other</option> </select> {Data?.type == "CORP" && ( <span className="input-group-text"> <FaEdit style={{ fontSize: "16px" }} /> </span> )} </div> </Col>

                <Col xxl={4} xl={4} lg={4} md={6} sm={12} className="mb-4"> <span className="fw-bold me-2">Email:</span> <div className="input-group input-group-sm user" style={{ flex: 1 }}> <input type="text" disabled={Data?.type !== "CORP"} className="form-control" value={maskEmail(Data?.emailId || "")} onChange={(e) => setData({ ...Data, emailId: e.target.value })} /> {Data?.type == "CORP" && ( <span className="input-group-text"> <FaEdit style={{ fontSize: "16px" }} /> </span> )} </div> </Col>

                <Col xxl={4} xl={4} lg={4} md={6} sm={12} className="mb-4"> <span className="fw-bold me-2">Mobile Number:</span> <div className="input-group input-group-sm user" style={{ flex: 1 }}> <input type="text" disabled={Data?.type !== "CORP"} className="form-control"  value={maskMobile(Data?.mobileNumber || "")} onChange={(e) => { const value = e.target.value; if (/^\d*$/.test(value)) { setData({ ...Data, mobileNumber: value }); } }} maxLength={10} /> {Data?.type == "CORP" && ( <span className="input-group-text"> <FaEdit style={{ fontSize: "16px" }} /> </span> )} </div> </Col>

                {Data?.type !== "CORP" && ( <Col xxl={4} xl={4} lg={4} md={6} sm={12} className="mb-4"> <span className="fw-bold me-2">Alternate Mobile Number:</span> <div className="input-group input-group-sm user" style={{ flex: 1 }}> <input type="text" className="form-control" value={maskMobile(Data?.alternateMobileNo || "")} onChange={(e) => { const value = e.target.value; if (/^\d*$/.test(value)) { setData({ ...Data, alternateMobileNo: value }); } }} maxLength={10} /> <span className="input-group-text"> <FaEdit style={{ fontSize: "16px" }} /> </span> </div> </Col> )}
              </Row>
              <Row className="mt-4">
                <Col xs={12} className="d-flex justify-content-center"> <Button variant="contained" color="primary" type="button" onClick={UpdateData} startIcon={<VscSaveAs />}> Update </Button> </Col>
              </Row>
            </Card.Body>
          </Card>
        )}
      </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
